import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LayoutService } from '@core/services/layout.service';
import { AuthService } from '@core/auth/services/auth.service';
import { PerfilService } from '../../../../features/perfil/services/perfil.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-header',
  imports: [RouterLink, MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header implements OnInit {
  readonly layout = inject(LayoutService);
  readonly auth = inject(AuthService);
  readonly perfil = inject(PerfilService);

  ngOnInit(): void {
    this.perfil.loadProfile();
  }
}
